import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { isMasaPenyesuaianBerlaku } from '../utils/presensiLogic';

export interface MasaPenyesuaian {
  aktif: boolean;
  /** Hari terakhir berlaku (YYYY-MM-DD, WIB); null = sampai dimatikan. */
  sampai: string | null;
  diubahOleh: string | null;
  diubahPada: string | null;
}


/**
 * Saklar global masa penyesuaian presensi (tabel `presensi_masa_penyesuaian`).
 * Selama berlaku, modal terlambat menampilkan pilihan "Lupa" dan "Aplikasi Error".
 */
export const useMasaPenyesuaian = () => {
  const [masa, setMasa] = useState<MasaPenyesuaian | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const { data, error } = await supabase
      .from('presensi_masa_penyesuaian')
      .select('*')
      .eq('id', 'default')
      .maybeSingle();
    if (error) {
      console.error('Gagal memuat masa penyesuaian presensi:', error);
    } else {
      setMasa({
        aktif: Boolean(data?.aktif),
        sampai: data?.sampai ?? null,
        diubahOleh: data?.diubah_oleh ?? null,
        diubahPada: data?.diubah_pada ?? null,
      });
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const simpan = async (aktif: boolean, sampai: string | null, oleh: string) => {
    const { error } = await supabase
      .from('presensi_masa_penyesuaian')
      .update({ aktif, sampai, diubah_oleh: oleh, diubah_pada: new Date().toISOString() })
      .eq('id', 'default');
    if (error) throw error;
    await refresh();
  };

  return { masa, loading, refresh, simpan, berlaku: isMasaPenyesuaianBerlaku(masa) };
};
